function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var Slide = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {HTMLElement} node
   * @param {Slider} slider
   */
  function Slide(node, slider) {
    _classCallCheck(this, Slide);
    this.node = node;
    this.slider = slider;
    this.node.classList.add('mc-slider__slide');
    this.prev = null;
    this.next = null;
    this.index = null;
  }

  /**
   * @return {Number}
   */
  return _createClass(Slide, [{
    key: "width",
    get: function get() {
      return parseFloat(window.getComputedStyle(this.node).width);
    }

    /**
     * @return {Number}
     */
  }, {
    key: "gap",
    get: function get() {
      return parseInt(window.getComputedStyle(this.node).marginRight, 10) || this.prev && this.prev.gap || 0;
    }

    /**
     * @param {Boolean} transition
     */
  }, {
    key: "translateTo",
    value: function translateTo() {
      var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var scrollValue = this.index * this.width + this.index * this.gap;
      this.slider.container.style[transition ? 'removeProperty' : 'setProperty']('scroll-behavior', 'auto');
      this.slider.container.scrollLeft = scrollValue;
      this.node.focus();
    }

    /**
     * @return {Boolean}
     */
  }, {
    key: "isFullyVisible",
    value: function isFullyVisible() {
      var containerBBox = this.slider.container.getBoundingClientRect();
      var bbox = this.node.getBoundingClientRect();
      return Math.floor(bbox.x) >= Math.floor(containerBBox.x) && Math.floor(bbox.x) + Math.floor(bbox.width) <= Math.floor(containerBBox.x) + Math.floor(containerBBox.width);
    }

    /**
     * @return {Number}
     */
  }, {
    key: "visibleWidth",
    get: function get() {
      var containerBBox = this.slider.container.getBoundingClientRect();
      var slideBBox = this.node.getBoundingClientRect();
      var maxLeft = Math.max(containerBBox.x, slideBBox.x);
      var minRight = Math.min(containerBBox.x + containerBBox.width, slideBBox.x + slideBBox.width);
      return minRight - maxLeft;
    }
  }]);
}();
export { Slide as default };